import { useTranslationApp } from "../../../../lib/i18next";
import TextField from "../../../Form/TextField";
import {
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  tiktokCurrenciesData,
  TIKTOK,
  ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION,
} from "../../../../utils/constants";
import {
  TARGET_CPA_PLACEHOLDER,
  BID_CONTROL_PLACEHOLDER,
  IN_CURRENCY,
  BID_GOAL_EXPLANATION,
  TARGET_CPA_EXPLANATION,
  OPTIMIZATION_GOAL_LINK_CLICKS,
  OPTIMIZATION_GOAL_THRUPLAY,
  OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS,
  OPTIMIZATION_GOAL_LEAD_GENERATION,
  OPTIMIZATION_GOAL_CPM,
  OPTIMIZATION_GOAL_CLICK_TO_APP,
  OPTIMIZATION_GOAL_CONVERSION_IN_APP,
} from "../../../../i18n/keysTranslations";
import NumberDecimalField from "../../../Form/NumberDecimalField";
import NumberField from "../../../Form/NumberField";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ChipOptional from "../../../Chip/ChipOptional";
import { getReactHookFormNestedError } from "../../../../utils/errors";

const BidGoalTikTok = ({
  control,
  name,
  errors,
  objective,
  disabled = false,
  currency,
  labelPosition = "separate",
  campaignType,
}) => {
  const { t } = useTranslationApp();

  const error = getReactHookFormNestedError(errors, name);

  const getOptimizationGoalCampaignTikTok = () => {
    switch (objective) {
      case ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION:
        return t(OPTIMIZATION_GOAL_CPM);

      case ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION:
        return t(OPTIMIZATION_GOAL_LINK_CLICKS);

      case ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION:
        return t(OPTIMIZATION_GOAL_THRUPLAY);

      case ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION:
        return t(OPTIMIZATION_GOAL_LEAD_GENERATION);

      case ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION:
        if (
          campaignType === ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION
        ) {
          return t(OPTIMIZATION_GOAL_CONVERSION_IN_APP);
        }
        return t(OPTIMIZATION_GOAL_CLICK_TO_APP);

      case ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION:
        return t(OPTIMIZATION_GOAL_OFFSITE_CONVERSIONS);

      default:
        return t(OPTIMIZATION_GOAL_LINK_CLICKS);
    }
  };

  const getBidGoalLabel = () => {
    switch (objective) {
      case ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION:
        return t(BID_CONTROL_PLACEHOLDER);

      case ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION:
      case ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION:
      case ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION:
      case ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION:
      case ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION:
        return t(TARGET_CPA_PLACEHOLDER);

      default:
        return t(TARGET_CPA_PLACEHOLDER);
    }
  };

  const label = getBidGoalLabel();
  const optimizationGoal = getOptimizationGoalCampaignTikTok();
  const isTargetCpa = label === t(TARGET_CPA_PLACEHOLDER);
  const finalLabel = `${label} ${t(IN_CURRENCY, { currency })}`;

  const tiktokCurrenciesWithDecimals = Object.keys(tiktokCurrenciesData).filter(
    (currencyKey) => tiktokCurrenciesData[currencyKey].precision === 0.01
  );

  if (objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION) {
    return null;
  }

  return (
    <>
      {labelPosition === "separate" && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Typography variant="body1">{finalLabel}</Typography>
          <ChipOptional size="small" />
        </Box>
      )}
      <TextField
        control={control}
        name={name}
        errors={errors}
        variant="filled"
        fullWidth
        label={labelPosition === "separate" ? "" : finalLabel}
        disabled={disabled}
        InputProps={{
          inputComponent: tiktokCurrenciesWithDecimals.includes(currency)
            ? NumberDecimalField
            : NumberField,
        }}
      />
      {!error?.message && (
        <Typography variant="caption" color="fields.placeholder">
          {`${t(isTargetCpa ? TARGET_CPA_EXPLANATION : BID_GOAL_EXPLANATION, {
            platform: t(TIKTOK),
          })} ${optimizationGoal}`}
        </Typography>
      )}
    </>
  );
};

export default BidGoalTikTok;
